import { Injector } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { TranslationService } from '../services/translation.service';

export class MissingHandler implements MissingTranslationHandler {
  private get translationService(): TranslationService {
    return this.injector.get(TranslationService);
  }
  constructor(private injector: Injector) {}

  handle(params: MissingTranslationHandlerParams): string | Observable<string> {
    let trad = "";
    // disabled for production
    let defaultText = null;
    if (params.interpolateParams)
      defaultText = (params.interpolateParams as any)["Default"];

    if (defaultText)
      trad = defaultText;
    else
      trad = params.key;

    return trad;
  }
}